// Wraps all protected routes. On mount, validates the persisted token by
// calling /api/auth/me — gives us instant feedback if the secret rotated or
// the user got disabled while the tab was closed.

import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth-store';
import { me } from '@/lib/auth-api';

export function AuthGate() {
  const token = useAuthStore((s) => s.token);
  const setUser = useAuthStore((s) => s.setUser);
  const clear = useAuthStore((s) => s.clear);
  const location = useLocation();

  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!token) {
      setReady(true);
      return;
    }
    me()
      .then((u) => {
        if (!cancelled) setUser(u);
      })
      .catch(() => {
        if (!cancelled) clear();
      })
      .finally(() => {
        if (!cancelled) setReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, [token, setUser, clear]);

  if (!ready) {
    return (
      <div className="h-screen flex items-center justify-center text-text-3 text-sm">Loading…</div>
    );
  }

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
